import { call, put } from "redux-saga/effects";
import { routes } from "../../common/api/routes";
import { getMentors,mentorsSuccess,mentorError } from "../actions";

export function* mentorSaga ({ payload }) {
    yield put(getMentors())
    try {
        const response = yield call(routes.getMentors, payload);
        yield put(mentorsSuccess(response));
      } catch (error) {
        yield put(mentorError(error));
      }
}